<template>
  <div
    class="z-[9999] mx-auto select-none rounded-md bg-white px-5 py-5 shadow-md lg:absolute lg:left-1/2 lg:top-32 lg:-translate-x-1/2 lg:-translate-y-1/2 lg:transform"
  >
    <PreloaderIcon class="mx-auto mb-2 text-zuno-turquoise" />
    <p class="text-center text-gray-500">
      {{ loaderText }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'LoaderComponent',

  props: {
    loaderText: {
      type: String,
      default: 'Loading...',
    },
  },
}
</script>
